import type { Color } from './color'

export const BLACK = '#212629' satisfies Color
export const WHITE = '#FFFFFF' satisfies Color
